export interface ApiErrorMessageProps {
  message: string | null;
}

export function ApiErrorMessage({message}: ApiErrorMessageProps) {
  if (!message) return null;
  const isMultiline = message.includes('\n');
  if (isMultiline) {
    return (
      <pre className="text-red-600 text-xs bg-red-50 border border-red-200 rounded p-2 overflow-auto max-h-64 whitespace-pre-wrap">
        {message}
      </pre>
    );
  }
  return <p className="text-red-600 text-sm">{message}</p>;
}
